// extracted by mini-css-extract-plugin
export default {"settingsMainWrapper":"Settings_settingsMainWrapper__k3ZdN"};